// extracted by mini-css-extract-plugin
export default {"regionsContainer":"branch_regionsContainer__zYQQ8","wrapper":"branch_wrapper__WBqqW"};